import ExitGameButton from "app/top-nav/ExitGameButton";
import GameMenu from "app/top-nav/GameMenu";
import { useScoreState } from "app/score/useScore";
import { useEffect, useRef } from "react";
import useAnimatedScorePopup from "app/utils/useAnimatedScorePopup";
import cn from "app/utils/classnames";

interface TopNavProps {
  hideMenuButton: boolean;
  onHowToPlayClick?: () => void;
  onCreditsClick?: () => void;
}

export default function TopNav(props: TopNavProps) {
  const { gameScore } = useScoreState();
  const prevGameScore = useRef(gameScore);

  const {
    animatePopup: animateScorePopup,
    visibleNumber: visibleScorePopupNumber,
    showPopup: showScorePopup,
  } = useAnimatedScorePopup();

  useEffect(() => {
    const difference = gameScore - prevGameScore.current;
    prevGameScore.current = gameScore;
    animateScorePopup(difference);
  }, [gameScore, animateScorePopup]);

  return (
    <div className="w-full basis-1 border-b border-b-dark shrink">
      {/* Div used to hide buttons*/}
      <div className="grid h-10 grid-cols-[2.5rem_1fr_2.5rem] items-center justify-between px-1 md:grid-cols-[12rem_1fr_12rem]">
        <ExitGameButton hideText className="justify-self-start" />
        <div className="flex-1 flex justify-center">
          <div className="relative">
            SCORE: {gameScore.toLocaleString()}
            <div
              className={cn(
                "absolute top-0 bottom-0 left-27",
                showScorePopup ? "opacity-100" : "opacity-0",
                showScorePopup ? "translate-x-0" : "translate-x-10",
                "transition-all duration-300 ease-in-out",
                "text-green-600",
              )}
            >
              +{visibleScorePopupNumber}
            </div>
          </div>
        </div>
        <div className="justify-self-end flex items-center justify-center gap-4">
          {!props.hideMenuButton && (
            <>
              <GameMenu>
                <button
                  role="menuitem"
                  className="cursor-pointer"
                  onClick={props.onHowToPlayClick}
                >
                  How to Play
                </button>
                <button
                  role="menuitem"
                  className="cursor-pointer"
                  onClick={props.onCreditsClick}
                >
                  Credits
                </button>
              </GameMenu>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
